import { QIcon_chevron_down, QIcon_chevron_up } from '@repo/icons/index'
import { useState } from 'react'
import { n_ai_speaking } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { CONVERSATION_AI_LIMIT } from '../../../../modules/vars'

const ProgressBar = ({ progress, showProgressDetail, setShowProgressDetail }) => {
  const calculatePercentage = () => {
    if (progress >= 1) return 100
    return progress * 100
  }
  const percentage = calculatePercentage()
  return (
    <div className="w-full flex items-center px-[16px] py-[4px]">
      <h4 className="w-full bg-gray-200 rounded-full overflow-hidden mr-[8px]">
        <div className="h-8 bg-purple-500" style={{ width: `${percentage}%` }} />
      </h4>
      {showProgressDetail ? (
        <QIcon_chevron_up onClick={() => setShowProgressDetail((r) => !r)} />
      ) : (
        <QIcon_chevron_down onClick={() => setShowProgressDetail((r) => !r)} />
      )}
    </div>
  )
}

const ConversationProgress = ({ turnCnt, isConversationQualified, wordCnt, minimumWord }) => {
  const { t } = useTranslation()
  const [showProgressDetail, setShowProgressDetail] = useState(false)
  return (
    <>
      <div className="flex flex-col items-center w-full z-100 bg-white bg-opacity-95 absolute">
        <ProgressBar
          progress={wordCnt / minimumWord}
          showProgressDetail={showProgressDetail}
          setShowProgressDetail={setShowProgressDetail}
        />
        {showProgressDetail && (
          <div className="items-center w-full z-100 flex item-center justify-center px-[12px] py-[4px]">
            <span className="Body2-14Md text-gray-500">{t(n_ai_speaking.b2b_wordcount.progress_txt1)}</span>
            <span className="bg-gray-200 w-1 h-[16px] inline-block mx-4" />
            <span className="Body2-14Md text-gray-700">{turnCnt}</span>
            <span className="Body2-14Md text-gray-400">/</span>
            <span className="Body2-14Md text-gray-400">
              {CONVERSATION_AI_LIMIT} {t(n_ai_speaking.b2b_wordcount.progress_txt2)}
            </span>
            {minimumWord ? (
              <>
                <span className="Body2-14Md text-gray-700 ml-[4px]">{wordCnt}</span>
                <span className="Body2-14Md text-gray-400">/</span>
                <span className="Body2-14Md text-gray-400">
                  {minimumWord} {t(n_ai_speaking.b2b_wordcount.wds)}
                </span>
              </>
            ) : null}
          </div>
        )}
      </div>
      {showProgressDetail && <div className="h-[20px]" />}
    </>
  )
}

export default ConversationProgress
